import React from 'react';
import styles from './NutritionalTableDay.module.css';
import { useSelector } from 'react-redux';

export default function ({
  menuDayProps = '',
  mealName = '',
  menuIndex = 0,
  indexIngredientGropIndex = 0,
  indexIngredient = 0,
}) {
  let menuDay;
  const menuAll = useSelector((state) => state.showMenu.menu);

  if (menuDayProps) {
    menuDay = menuDayProps;
  } else {
    menuDay = useSelector((state) => state.menu.menuDay);
  }

  // Отримує КБЖВ вчорашнього дня
  const getYesterdaysValue = (menuAll, dayNumber, meal = '') => {
    const energy = {
      сaloriesIngredients: 0,
      proteinIngredients: 0,
      fatsIngredients: 0,
      carbohydratesIngredients: 0,
    };

    // Чи знайдений вчорашній день меню
    let isMenuDay = false;

    const menuKeys = Object.keys(menuAll);

    for (let index = 0; index < menuKeys.length; index++) {
      const menuObject = menuAll[menuKeys[index]];

      if (
        Number(menuObject.dayNumber) === Number(dayNumber - 1) &&
        menuObject[meal] &&
        menuObject[meal].menuText &&
        menuObject[meal].menuText[0] &&
        menuObject[meal].menuText[0].ingredients.length
      ) {
        // знайдений вчорашній день меню
        isMenuDay = true;

        // Додаєм КБЖВ в обєкт "energy"
        menuObject[meal].menuText[0].ingredients.forEach((item) => {
          if (!item.titleIngredients) {
            if (Number(item.ingredientsItems[0].сaloriesIngredient)) {
              energy.сaloriesIngredients =
                Number(energy.сaloriesIngredients) +
                Number(item.ingredientsItems[0].сaloriesIngredient);
            }
            if (Number(item.ingredientsItems[0].proteinIngredient)) {
              energy.proteinIngredients =
                Number(energy.proteinIngredients) +
                Number(item.ingredientsItems[0].proteinIngredient);
            }

            if (Number(item.ingredientsItems[0].fatsIngredient)) {
              energy.fatsIngredients =
                Number(energy.fatsIngredients) + Number(item.ingredientsItems[0].fatsIngredient);
            }

            if (Number(item.ingredientsItems[0].carbohydratesIngredient)) {
              energy.carbohydratesIngredients =
                Number(energy.carbohydratesIngredients) +
                Number(item.ingredientsItems[0].carbohydratesIngredient);
            }
          }
        });
      }
    }

    if (isMenuDay) {
      return energy;
    }
    return false;
  };

  const getValue = (
    meal = '',
    menuIndex = 0,
    indexIngredientGropIndex = 0,
    indexIngredient = 0,
  ) => {
    const energy = {
      сaloriesIngredients: 0,
      proteinIngredients: 0,
      fatsIngredients: 0,
      carbohydratesIngredients: 0,
    };

    if (menuDay[meal].menuText.length) {
      const mealIngredients = menuDay[meal].menuText[menuIndex].ingredients;

      const getIndex = (index, indexIngredientGropIndex, indexIngredient) => {
        if (index === indexIngredientGropIndex) {
          return indexIngredient;
        } else {
          return 0;
        }
      };

      mealIngredients.forEach((item, index) => {
        // console.log('mealIngredients/item == ', item);

        if (
          item.ingredientsItems[getIndex(index, indexIngredientGropIndex, indexIngredient)] &&
          item.ingredientsItems[getIndex(index, indexIngredientGropIndex, indexIngredient)]
            .сaloriesIngredient
        ) {
          energy.сaloriesIngredients =
            Number(energy.сaloriesIngredients) +
            Number(
              item.ingredientsItems[getIndex(index, indexIngredientGropIndex, indexIngredient)]
                .сaloriesIngredient,
            );
        }
        //
        if (
          item.ingredientsItems[getIndex(index, indexIngredientGropIndex, indexIngredient)] &&
          item.ingredientsItems[getIndex(index, indexIngredientGropIndex, indexIngredient)]
            .proteinIngredient
        ) {
          energy.proteinIngredients =
            Number(energy.proteinIngredients) +
            Number(
              item.ingredientsItems[getIndex(index, indexIngredientGropIndex, indexIngredient)]
                .proteinIngredient,
            );
        }
        //
        if (
          item.ingredientsItems[getIndex(index, indexIngredientGropIndex, indexIngredient)] &&
          item.ingredientsItems[getIndex(index, indexIngredientGropIndex, indexIngredient)]
            .fatsIngredient
        ) {
          energy.fatsIngredients =
            Number(energy.fatsIngredients) +
            Number(
              item.ingredientsItems[getIndex(index, indexIngredientGropIndex, indexIngredient)]
                .fatsIngredient,
            );
        }
        //
        if (
          item.ingredientsItems[getIndex(index, indexIngredientGropIndex, indexIngredient)] &&
          item.ingredientsItems[getIndex(index, indexIngredientGropIndex, indexIngredient)]
            .carbohydratesIngredient
        ) {
          energy.carbohydratesIngredients =
            Number(energy.carbohydratesIngredients) +
            Number(
              item.ingredientsItems[getIndex(index, indexIngredientGropIndex, indexIngredient)]
                .carbohydratesIngredient,
            );
        }
      });
    }

    if (menuDay[meal].repeatMenu) {
      // console.log('repeatMenu/menuDay.dayNumber === ', menuDay.dayNumber);
      // console.log('repeatMenu/meal === ', meal);

      const energyYesterdays = getYesterdaysValue(menuAll, menuDay.dayNumber, meal);

      if (energyYesterdays) {
        energy.сaloriesIngredients =
          Number(energy.сaloriesIngredients) + Number(energyYesterdays.сaloriesIngredients);

        energy.proteinIngredients =
          Number(energy.proteinIngredients) + Number(energyYesterdays.proteinIngredients);

        energy.fatsIngredients =
          Number(energy.fatsIngredients) + Number(energyYesterdays.fatsIngredients);

        energy.carbohydratesIngredients =
          Number(energy.carbohydratesIngredients) +
          Number(energyYesterdays.carbohydratesIngredients);
      }
    }

    return energy;
  };

  const energyBreakfast = getValue(
    'breakfast',
    mealName === 'breakfast' ? menuIndex : 0,
    mealName === 'breakfast' ? indexIngredientGropIndex : 0,
    mealName === 'breakfast' ? indexIngredient : 0,
  );
  const energySnack = getValue(
    'snack',
    mealName === 'snack' ? menuIndex : 0,
    mealName === 'snack' ? indexIngredientGropIndex : 0,
    mealName === 'snack' ? indexIngredient : 0,
  );
  const energyDinner = getValue(
    'dinner',
    mealName === 'dinner' ? menuIndex : 0,
    mealName === 'dinner' ? indexIngredientGropIndex : 0,
    mealName === 'dinner' ? indexIngredient : 0,
  );
  const energySupper = getValue(
    'supper',
    mealName === 'supper' ? menuIndex : 0,
    mealName === 'supper' ? indexIngredientGropIndex : 0,
    mealName === 'supper' ? indexIngredient : 0,
  );

  const getValueToFixed = (valueProps) => {
    const value = Number(valueProps);
    if (value) {
      return Number(value.toFixed(1));
    }
    return '-';
  };

  // Вираховує обше КБЖВ за день
  const getTotalValue = (energyBreakfast, energySnack, energyDinner, energySupper) => {
    const totalEnergy = {
      сaloriesIngredients: 0,
      proteinIngredients: 0,
      fatsIngredients: 0,
      carbohydratesIngredients: 0,
    };

    const getValeuTotalItem = (energy) => {
      return (
        Number(energyBreakfast[energy]) +
        Number(energySnack[energy]) +
        Number(energyDinner[energy]) +
        Number(energySupper[energy])
      );
    };

    totalEnergy.сaloriesIngredients = getValeuTotalItem('сaloriesIngredients');
    totalEnergy.proteinIngredients = getValeuTotalItem('proteinIngredients');
    totalEnergy.fatsIngredients = getValeuTotalItem('fatsIngredients');
    totalEnergy.carbohydratesIngredients = getValeuTotalItem('carbohydratesIngredients');

    return totalEnergy;
  };

  // Обші КБЖВ за день
  const totalEnergy = getTotalValue(energyBreakfast, energySnack, energyDinner, energySupper);

  // console.log(mealName, menuIndex, indexIngredientGropIndex, indexIngredient);
  // console.log('totalEnergy === ', totalEnergy);
  // console.log('energyBreakfast === ', energyBreakfast);
  // console.log('energySnack === ', energySnack);
  // console.log('energyDinner === ', energyDinner);
  // console.log('energySupper === ', energySupper);

  return (
    <div className={styles.table_wrapper}>
      <div className={styles.table_item}></div>
      <div
        className={
          mealName === 'breakfast'
            ? styles.table_item + ' ' + styles.table_item_active
            : styles.table_item
        }>
        Сніданок
      </div>
      <div
        className={
          mealName === 'snack'
            ? styles.table_item + ' ' + styles.table_item_active
            : styles.table_item
        }>
        Перекус
      </div>
      <div
        className={
          mealName === 'dinner'
            ? styles.table_item + ' ' + styles.table_item_active
            : styles.table_item
        }>
        Обід
      </div>
      <div
        className={
          mealName === 'supper'
            ? styles.table_item + ' ' + styles.table_item_active
            : styles.table_item
        }>
        Вечеря
      </div>
      <div className={styles.table_item + ' ' + styles.table_item_total}>Всього</div>
      <div className={styles.table_item}>Ккал</div>
      <div
        className={
          mealName === 'breakfast'
            ? styles.table_item + ' ' + styles.table_item_active
            : styles.table_item
        }>
        {getValueToFixed(energyBreakfast.сaloriesIngredients)}
      </div>
      <div
        className={
          mealName === 'snack'
            ? styles.table_item + ' ' + styles.table_item_active
            : styles.table_item
        }>
        {getValueToFixed(energySnack.сaloriesIngredients)}
      </div>
      <div
        className={
          mealName === 'dinner'
            ? styles.table_item + ' ' + styles.table_item_active
            : styles.table_item
        }>
        {getValueToFixed(energyDinner.сaloriesIngredients)}
      </div>
      <div
        className={
          mealName === 'supper'
            ? styles.table_item + ' ' + styles.table_item_active
            : styles.table_item
        }>
        {getValueToFixed(energySupper.сaloriesIngredients)}
      </div>
      <div className={styles.table_item + ' ' + styles.table_item_total}>
        {getValueToFixed(totalEnergy.сaloriesIngredients)}
      </div>
      <div className={styles.table_item}>Білки</div>
      <div
        className={
          mealName === 'breakfast'
            ? styles.table_item + ' ' + styles.table_item_active
            : styles.table_item
        }>
        {getValueToFixed(energyBreakfast.proteinIngredients)}
      </div>
      <div
        className={
          mealName === 'snack'
            ? styles.table_item + ' ' + styles.table_item_active
            : styles.table_item
        }>
        {getValueToFixed(energySnack.proteinIngredients)}
      </div>
      <div
        className={
          mealName === 'dinner'
            ? styles.table_item + ' ' + styles.table_item_active
            : styles.table_item
        }>
        {getValueToFixed(energyDinner.proteinIngredients)}
      </div>
      <div
        className={
          mealName === 'supper'
            ? styles.table_item + ' ' + styles.table_item_active
            : styles.table_item
        }>
        {getValueToFixed(energySupper.proteinIngredients)}
      </div>
      <div className={styles.table_item + ' ' + styles.table_item_total}>
        {getValueToFixed(totalEnergy.proteinIngredients)}
      </div>
      <div className={styles.table_item}>Жири</div>
      <div
        className={
          mealName === 'breakfast'
            ? styles.table_item + ' ' + styles.table_item_active
            : styles.table_item
        }>
        {getValueToFixed(energyBreakfast.fatsIngredients)}
      </div>
      <div
        className={
          mealName === 'snack'
            ? styles.table_item + ' ' + styles.table_item_active
            : styles.table_item
        }>
        {getValueToFixed(energySnack.fatsIngredients)}
      </div>
      <div
        className={
          mealName === 'dinner'
            ? styles.table_item + ' ' + styles.table_item_active
            : styles.table_item
        }>
        {getValueToFixed(energyDinner.fatsIngredients)}
      </div>
      <div
        className={
          mealName === 'supper'
            ? styles.table_item + ' ' + styles.table_item_active
            : styles.table_item
        }>
        {getValueToFixed(energySupper.fatsIngredients)}
      </div>
      <div className={styles.table_item + ' ' + styles.table_item_total}>
        {getValueToFixed(totalEnergy.fatsIngredients)}
      </div>

      <div className={styles.table_item}>Вугл</div>
      <div
        className={
          mealName === 'breakfast'
            ? styles.table_item + ' ' + styles.table_item_active
            : styles.table_item
        }>
        {getValueToFixed(energyBreakfast.carbohydratesIngredients)}
      </div>
      <div
        className={
          mealName === 'snack'
            ? styles.table_item + ' ' + styles.table_item_active
            : styles.table_item
        }>
        {getValueToFixed(energySnack.carbohydratesIngredients)}
      </div>
      <div
        className={
          mealName === 'dinner'
            ? styles.table_item + ' ' + styles.table_item_active
            : styles.table_item
        }>
        {getValueToFixed(energyDinner.carbohydratesIngredients)}
      </div>
      <div
        className={
          mealName === 'supper'
            ? styles.table_item + ' ' + styles.table_item_active
            : styles.table_item
        }>
        {getValueToFixed(energySupper.carbohydratesIngredients)}
      </div>
      <div className={styles.table_item + ' ' + styles.table_item_total}>
        {getValueToFixed(totalEnergy.carbohydratesIngredients)}
      </div>
    </div>
  );
}
